import { useEffect, useState } from "react";

interface ObjectUrlState {
	blob: Blob;
	objectUrl: string;
}

export const useObjectUrl = (blob: Blob | null) => {
	const [preview, setPreview] = useState<ObjectUrlState | null>(null);

	useEffect(() => {
		if (!blob) {
			setPreview(null);
			return;
		}

		const objectUrl = URL.createObjectURL(blob);
		setPreview({ blob, objectUrl });

		return () => URL.revokeObjectURL(objectUrl);
	}, [blob]);

	return preview?.blob === blob ? preview.objectUrl : null;
};
